/* eslint-disable no-restricted-syntax */
import React, { useContext } from 'react';
import { Route, useHistory } from 'react-router-dom';
import RemoveIndexFromRoute from './removeIndexFromRoute';
import { ContextPerson } from '../../store/contexts/contextPerson';

export const ProtectedAfiliadoRoute = ({ children, ...rest }) => {
  const { pessoa, isPersonLoaded } = useContext(ContextPerson);
  const history = useHistory();

  const verifyTypeToAccessRoute = () => {
    if (pessoa && pessoa.afiliacao && !pessoa.vinculo) {
      return (
        <React.Fragment>
          <RemoveIndexFromRoute />
          {children}
        </React.Fragment>
      );
    }
    history.push('/painel');
    return <></>;
  };

  return (
    <>
      {isPersonLoaded && history && (
        <Route
          {...rest}
          render={() => {
            return verifyTypeToAccessRoute();
          }}
        />
      )}
    </>
  );
};
